import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ADD-DEPOSIT-MODAL';

export const {action: showAddDepositModal} = createAction(
    `${domain}/SHOW`,
    (institutionId, childId, showPaidExternally) => ({childId, institutionId, showPaidExternally}),
);

export const {action: showEditDepositModal} = createAction(`${domain}/EDIT`, (institutionId, childId, deposit) => ({
    childId,
    institutionId,
    deposit,
}));

export const {success: searchForBillPayerSuccess, failed: searchForBillPayerFailed} = createAction(
    `${domain}/SEARCH_BILL_PAYERS`,
    () => ({}),
    searchItems => ({searchItems}),
);

export const {action: hideDepositModal} = createAction(`${domain}/HIDE`);
